import React from "react";
import reqLayout from "../../_common/hoc/layout";
import NewJobPostingMain from "../../components/job-posting/NewJobPostingMain";
import Sidebar from "../../components/common/Sidebar";
import { RODEO_PAGE_NAME } from "../../_config";
import Header from "src/components/common/Header";
import Footer from "src/components/common/Footer";

const NewJobPostingPage: React.FC = () => {
  return (
    <>
     <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.NEW_JOB_POSTING} />
      <NewJobPostingMain />
      <Footer variant="dashboard" />
    </>
  );
};

export default reqLayout(NewJobPostingPage);